import React from 'react';

import { StyledLoading } from './styles';
import Dots from './variants/Dots';
import Spinner from './variants/Spinner';

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'circular' | 'dots';
  size?: number;
}

const Loading = React.forwardRef<HTMLDivElement, LoadingProps>(
  ({ variant = 'circular', children, size, ...props }, ref) => {
    return (
      <StyledLoading size={size} {...props} ref={ref}>
        {variant === 'circular' && <Spinner />}
        {variant === 'dots' && <Dots />}
      </StyledLoading>
    );
  }
);

export default Loading;
